<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      <b>Date Type Question</b>
    </div>    
    <div [hidden]="folderId == -1">
      <div class="bg-info p-1 mb-3">
        <div class="row">
          <div class="col-md-10">
            <span class="text-white pt-2" style="font-size:18px; display:inline-block"><b>Folder Name : </b>{{ folderName }}</span>
          </div>
          <div class="col-md-2 py-1">
            <button type="button" class="btn btn-primary btn-action" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==null || redirectedSurveyId==null"><i class="fa fa-arrow-left"></i> Back to Section</button>
            <button type="button" class="btn btn-primary btn-action mb-0" (click)="backUrl()"><i class="fa fa-home"></i> Home</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-header nocollapse bg-info col-md-12 " *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>

    <div class="col-md-12 card-body">

      <form [formGroup]="questionDateTimeTypeForm" #f="ngForm">
        <div class="row mb-3">
          <label data-required for="questionDescription" class="form-control-label col-md-2">Question Title</label>
          <div class="col-md-10">
            <textarea rows="6" cols="13" maxlength="1000" id="questionDescription" name="questionDescription" formControlName="questionDescription" class=" form-control form-control-label" placeholder="Please Enter Question Title" #questionDescription></textarea>
          </div>
        </div>
        <div class="row mb-3">
          <label class="form-control-label col-md-2" for="questionCategoryId"> Category</label>
          <div class="col-md-3">
            <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId" class="form-control">
              <option value="" selected>--Select--</option>
              <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId" [selected]="questionCategoryId==item?.questionCategoryId">
                {{item.questionCategoryName}}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <button type="button" style="margin-left:14px;" class="btn btn-primary btn-action"
                    (click)="openCategoryModal()">
              <i class="fa fa-plus"></i> Create Category
            </button>
          </div>
          <label class="col-md-1 form-control-label" for="shortName">Short Name</label>
          <div class="col-md-3"><input class="form-control" maxlength="30" type="text" id="shortName" name="shortName" formControlName="shortName" placeholder="Short Name" /></div>
        </div>
        <div class="row mb-3">
          <div class="col-md-8"></div>
          <div class="col-md-3">
            <button type="submit" [disabled]="!questionDateTimeTypeForm.valid" class="btn btn-primary btn-action pull-right" (click)="savequestionDescription()"><i class="fa fa-save"></i> Save</button>
            <button type="submit" class="btn btn-secondary btn-action pull-right" (click)="backUrl()" [hidden]="redirectedSectionId!=null || redirectedSurveyId!=null"><i class="fa fa-times"></i> Cancel</button>
            <button type="button" class="btn btn-secondary btn-action pull-right" (click)="backToSectionUrl()" [hidden]="redirectedSectionId==undefined || redirectedSurveyId==undefined"><i class="fa fa-times"></i> Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<ng-template #CreateUpdateQsCategoryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Create Category</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="ResetQuesCategoryForm(); modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="quesCategoryForm" #f="ngForm">
      <div class="row align-items-center">
        <label data-required class="form-control-label col-md-4" for="quesCategoryName">Category</label>
        <div class="col-md-8">
          <input class="form-control" type="text" id="quesCategoryName" name="quesCategoryName" formControlName="quesCategoryName" placeholder="Category" />
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="ResetQuesCategoryForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
    <button type="button" class="btn btn-primary btn-modal" [disabled]="!quesCategoryForm.valid" (click)="AddQuesCategory(); modal.close()"><i class="fa fa-save"></i> Save</button>
  </div>
</ng-template>
